import React, {useState} from 'react'
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from './shared/helper';

const Signup = (props) => {
  
    const [credentials, setCredentials] = useState({name:"", email: "", password: "", confirmPassword:""});
    const navigate = useNavigate();
  
    const onChange = (e) => {
        setCredentials({...credentials, [e.target.name]: e.target.value});
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // const url = "http://localhost:5000";
        const url = `${BASE_URL}/api/auth/createuser`;
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({name:credentials.name, email: credentials.email, password: credentials.password})
        });
    
        
        const jsonResponse = await response.json();
        console.log(jsonResponse)
        if(jsonResponse.success){
          // save auth-token and redirect
          localStorage.setItem('token', jsonResponse.authToken);
          
          navigate("/");

          props.showNotif("Account Created!", "success");

        } else{
            props.showNotif("Invalid Credentials", "danger");
        }
        // reset form input
        e.target.reset();
      }

    return (
        <div className='mt-2'>
            <h2 className='my-2'>Create an account, with us!</h2>
            <form onSubmit={handleSubmit}>
                <div className="my-3">
                    <label htmlFor="name" className="form-label">Name</label>
                    <input type="text" className="form-control" id="name" onChange={onChange} name="name" required/>
                </div>
                <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email</label>
                    <input type="email" className="form-control" id="email" aria-describedby="emailHelp" onChange={onChange} name="email" required/>
                    <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div>
                </div>
                <div className="mb-3">
                    <label htmlFor="password" className="form-label">Password</label>
                    <input type="password" className="form-control" id="password" onChange={onChange} name="password" required minLength={5}/>
                </div>
                <div className="mb-3">
                    <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
                    <input type="password" className="form-control" id="confirmPassword" onChange={onChange} name="confirmPassword" required minLength={5}/>
                </div>
                <button type="submit" className="btn btn-primary">Submit</button>
            </form>
        </div>
    )
}

export default Signup
